import axios from 'axios';
import { Auth } from 'aws-amplify';

const api = axios.create({});

api.interceptors.request.use(
    async (config) => {
        try {
            const session = await Auth.currentSession();
            const token = session.getAccessToken().getJwtToken();

            config.headers = config.headers ?? {};
            config.headers.Authorization = `Bearer ${token}`;

            const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;

            if (!isFormData) {
                config.headers['Content-Type'] = 'application/json';
            } else {
                delete config.headers['Content-Type'];
            }
        } catch (error) {
            console.error(`Error attaching JWT token`, error);
        }
        return config;
    }
);

export default api;